import { render, staticRenderFns } from "./InvoiceHistoryPage.vue?vue&type=template&id=738c4f95&scoped=true&"
import script from "./InvoiceHistoryPage.vue?vue&type=script&lang=js&"
export * from "./InvoiceHistoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738c4f95",
  null
  
)

export default component.exports